import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=f824852a&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/product/Products/ProductsStyle.css?vue&type=style&index=0&id=f824852a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f824852a",
  null
  
)

export default component.exports